import http from '@/plugins/axios'

class ParceirosService {
  async getAll() { 
    const response = await http.get('/parceiros')
    return response.data 
  }

  async create(data) { 
    const response = await http.post('/parceiros', data)
    return response.data
  }

  async update(id, data) { 
    const response = await http.patch(`/parceiros/${id}`, data)
    return response.data
  }

  async delete(id) { 
    const response = await http.delete(`/parceiros/${id}`)
    return response.data
  }
}

export default new ParceirosService()